var _circle, _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerySafe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 73,
    viewBox: "0 0 104 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 36.5,
    r: 36.266,
    fill: "url(#paint0_linear_506_3297)",
    stroke: "#81A9D7",
    strokeWidth: 0.467949
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5165 21.6545C77.5894 21.612 77.663 21.569 77.7374 21.5256C78.3617 21.1614 78.9668 20.8454 79.5552 20.5751C82.2679 25.2587 83.8207 30.698 83.8207 36.5C83.8207 54.074 69.5742 68.3205 52.0002 68.3205C34.4262 68.3205 20.1797 54.074 20.1797 36.5C20.1797 31.6712 21.2553 27.0936 23.18 22.9937C23.5112 23.1038 23.838 23.2148 24.1612 23.3245C28.3328 24.7409 31.9026 25.953 36.5579 22.4615C44.0451 16.8461 52.9361 17.3141 61.8271 21.5256C70.6091 25.6855 71.6497 25.0782 77.5165 21.6545Z",
    fill: "url(#paint1_linear_506_3297)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_506_3297)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 35.5,
    rx: 41.5,
    ry: 16.5,
    fill: "url(#paint2_linear_506_3297)",
    fillOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.46 28.148H43.732V39.26H42.46V36.548H38.992V35.36H42.46V33.812H39.544V32.612H42.46V31.112H39.268V29.924H42.46V28.148ZM45.268 28.148H46.54V29.924H49.72V31.112H46.54V32.612H49.456V33.812H46.54V35.36H49.912V36.548H46.54V39.26H45.268V28.148ZM55.864 34.496H53.26V31.628H59.788V34.496H57.136V35.168H60.928V37.388C60.928 38.228 60.488 38.648 59.608 38.648H58.72L58.384 37.46L59.212 37.508C59.532 37.508 59.692 37.372 59.692 37.1V36.296H57.136V39.248H55.864V36.296H53.344V38.732H52.108V35.168H55.864V34.496ZM55.864 28.088H57.136V29.792H58.372C58.716 29.272 59 28.752 59.224 28.232L60.412 28.676C60.188 29.092 59.96 29.464 59.728 29.792H61.684V32.444H60.412V30.98H52.588V32.456H51.316V29.792H53.176C52.976 29.424 52.748 29.08 52.492 28.76L53.68 28.316C53.944 28.732 54.196 29.224 54.436 29.792H55.864V28.088ZM58.576 33.464V32.672H54.484V33.464H58.576ZM49.672 44.204V46.976H48.4V45.416H40.588V46.964H39.316V44.204H43.756C43.628 43.916 43.464 43.608 43.264 43.28L44.68 43.04C44.816 43.32 44.98 43.708 45.172 44.204H49.672ZM39.172 47.528H42.472C42.752 47.008 43.068 46.396 43.42 45.692L44.716 46.088L43.96 47.528H49.852V48.728H47.572C47.108 49.856 46.604 50.772 46.06 51.476C47.26 51.98 48.46 52.56 49.66 53.216L48.808 54.32C47.584 53.592 46.368 52.956 45.16 52.412C43.808 53.58 42.044 54.196 39.868 54.26L39.136 53.096C41.08 53.096 42.652 52.676 43.852 51.836C42.772 51.38 41.708 50.988 40.66 50.66C41.108 49.948 41.492 49.304 41.812 48.728H39.172V47.528ZM43.288 48.728C42.976 49.264 42.688 49.744 42.424 50.168C43.144 50.368 43.944 50.636 44.824 50.972C45.368 50.356 45.824 49.608 46.192 48.728H43.288ZM56.944 43.112C58.448 44.648 60.176 45.86 62.128 46.748L61.504 47.864C60.928 47.584 60.376 47.284 59.848 46.964V48.044H57.136V49.724H60.472V50.936H57.136V52.712H61.564V53.936H51.448V52.712H55.864V50.936H52.516V49.724H55.864V48.044H53.152V46.952C52.6 47.296 52.032 47.608 51.448 47.888L50.836 46.772C52.94 45.78 54.68 44.56 56.056 43.112H56.944ZM59.644 46.832C58.476 46.096 57.428 45.236 56.5 44.252C55.62 45.204 54.568 46.064 53.344 46.832H59.644Z",
    fill: "#112C56"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_506_3297",
    x: 0.0179482,
    y: 8.51795,
    width: 103.964,
    height: 53.9641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.24103,
    result: "effect1_foregroundBlur_506_3297"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_506_3297",
    x1: 52,
    y1: 0,
    x2: 52,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10234E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16547B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_506_3297",
    x1: 83.8207,
    y1: 36.868,
    x2: 20.1797,
    y2: 36.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15A0E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491939,
    stopColor: "#8ED9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EA4EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_506_3297",
    x1: 93.5,
    y1: 35.5,
    x2: 10.5,
    y2: 35.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491939,
    stopColor: "#69CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A7E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerySafe);
export default __webpack_public_path__ + "static/media/very-safe.395094da5d7de57048d14a3937276b41.svg";
export { ForwardRef as ReactComponent };